import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export const USER_ENGAGEMENT_ELEMENT_IDS = {
  TEST_ELEMENT: 'test-element', // Used for the tests
  BENCHMARK_INSIGHT_LIGHT_ONBOARDING_MODAL:
    'benchmark-insight-light-onboarding-modal',
  CENTRAL_MAPPING_HIERARCHY_ONBOARDING_MODAL:
    'central-mapping-hierarchy-onboarding-modal',
  CENTRAL_MAPPING_MAPPING_ONBOARDING_MODAL:
    'central-mapping-mapping-onboarding-modal',
  HOTEL_CURRENCY_CONVERSION_ONBOARDING_MODAL:
    'hotel-currency-conversion-onboarding-modal',
  MARKET_CURRENCY_CONVERSION_ONBOARDING_MODAL:
    'market-currency-conversion-onboarding-modal',
} as const;

export type UserEngagementElementId =
  (typeof USER_ENGAGEMENT_ELEMENT_IDS)[keyof typeof USER_ENGAGEMENT_ELEMENT_IDS];

export const isUserEngagelementElementId = (
  id: string,
): id is UserEngagementElementId => {
  return Object.values(USER_ENGAGEMENT_ELEMENT_IDS).includes(
    id as UserEngagementElementId,
  );
};

export default class SeenUserEngagementElement extends Model {
  [Type] = 'seen-user-engagement-element' as const;

  @attr('string') declare elementId: UserEngagementElementId;
}
